import { Typography } from "@mui/material";

export default function TermsOfService() {
  return (
    <Typography fontSize="0.75rem">
      By selecting <b>Agree and continue</b>, I agree to Airbnsea’s Terms of
      Service, Payments Terms of Service, and Nondiscrimination Policy and
      acknowledge the Privacy Policy.
    </Typography>
  );
}
